/* @flow */
import * as React from "react";
import styled from "styled-components";
import { timeFormat } from "d3-time-format";
import * as d3 from "d3-time";

/* prettier-ignore */
var formatMillisecond = timeFormat(".%L"),
    formatSecond = timeFormat("%H:%M:%S"),
    formatMinute = timeFormat("%H:%M"),
    formatHour = timeFormat("%H:%M"),
    formatDay = timeFormat("%d/%m"),
    formatWeek = timeFormat("%d/%m"),
    formatMonth = timeFormat("%B %Y"),
    formatYear = timeFormat("%Y");

/* prettier-ignore */
function multiFormat(date) {
  return (d3.timeSecond(date) < date ? formatMillisecond
      : d3.timeMinute(date) < date ? formatSecond
      : d3.timeHour(date) < date ? formatMinute
      : d3.timeDay(date) < date ? formatHour
      : d3.timeMonth(date) < date ? (d3.timeWeek(date) < date ? formatDay : formatWeek)
      : d3.timeYear(date) < date ? formatMonth
      : formatYear)(date);
}

const HorizontalContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 3px;
  left: 0px;
  height: 24px;
  padding-right: 30px;
  background-color: ${props => props.theme.main};

  &:after {
    content: "";
    position: absolute;
    left: 28px;
    right: 30px;
    bottom: 0px;
    border-bottom: 1px solid ${props => props.theme.ticksBorderColor};
  }
`;

const MobileHorizontalContainer = styled(HorizontalContainer)`
  width: 100%;
  padding-left: 0;
  padding-right: 0;

  &:after {
    left: 0;
    right: 0;
    border-bottom-color: ${props => props.theme.ticksBorderColor};
  }
`;

const HorizontalInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${props => props.theme.main};
`;

const HorizontalContainerBottom = styled(HorizontalContainer)`
  top: auto;
  bottom: 0px;
  height: 43px;

  &:after {
    top: 0px;
    bottom: auto;
  }
`;

const VerticalContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 50px;
  bottom: 0px;
  width: 120px;
`;

/*const MobileVerticalContainer = styled(VerticalContainer)`
  right: 21px;
`;*/

const Tick = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: inline-block;
  vertical-align: middle;
  width: 120px;
  height: 24px;
  color: ${props => props.theme.ticksFontColor};
  font-size: ${({theme}) => theme.locale === "ar" ? "11px" : "11px"};
  line-height: 20px;
  user-select: none;
`;

const HorizontalTick = styled(Tick)`
  margin-left: -60px;
  text-align: center;

  &:after {
    position: absolute;
    left: 50%;
    bottom: 1px;
    display: block;
    width: 1px;
    height: 2px;
    background-color: ${props => props.theme.ticksBorderColor};
    content: "";
  }
`;

const MobileHorizontalTick = styled(HorizontalTick)`
  margin-top: 5px;
  font-size: ${({theme}) => theme.locale === "ar" ? "10px" : "10px"};
  color: ${props => props.theme.ticksFontColor};

  &:after {
    bottom: 6px;
    background-color: ${props => props.theme.ticksBorderColor};
  }
`;

const HorizontalTickBottom = styled(Tick)`
  line-height: 30px;
  margin-left: -60px;
  text-align: center;

  &:after {
    position: absolute;
    left: 50%;
    top: 0px;
    bottom: auto;
    display: block;
    width: 1px;
    height: 2px;
    background-color: ${props => props.theme.ticksBorderColor};
    content: "";
  }
`;

const VerticalTick = styled(Tick)`
  text-align: right;
`;

/*const MobileVerticalTick = styled(VerticalTick)`
  font-size: ${({theme}) => theme.locale === "ar" ? "10px" : "10px"};
`;*/

type HorizontalTicksProps = {
  scaleX: (date: number) => number,
  ticks: Array<number>,
  mobile?: boolean
};

class Ticks extends React.Component {
  shouldComponentUpdate(nextProps) {
    // console.log(nextProps);
    //return +nextProps.ticks[0] !== +this.props.ticks[0];
    return true;
  }

  render() {
    const Component = this.props.component;
    return this.props.ticks
      .map(tick => ({ value: tick, x: this.props.scaleX(tick) }))
      .filter(
        (tick, index, ticks) =>
          index === ticks.length - 1 || tick.x !== ticks[index + 1].x
      )
      .map(tick => (
        <Component
          key={+tick.value}
          style={{
            left: `${Math.floor(tick.x) - this.props.offset}px`
          }}
        >
          {multiFormat(tick.value)}
        </Component>
      ));
  }
}

export function HorizontalTicks(props: HorizontalTicksProps) {
  const offset = Math.floor(props.scaleX(props.ticks[0]));

  if (props.mobile) {
    return (
      <MobileHorizontalContainer>
        <HorizontalInner>
          <div
            style={{
              position: "relative",
              willChange: "transform",
              WebkitTransform: `translateX(${offset}px`,
              transform: `translateX(${offset}px`
            }}
          >
            <Ticks
              component={MobileHorizontalTick}
              offset={offset}
              scaleX={props.scaleX}
              ticks={props.ticks}
            />
          </div>
        </HorizontalInner>
      </MobileHorizontalContainer>
    );
  }

  return [
    <HorizontalContainer key="top" style={{ cursor: "default", zIndex: 2 }}>
      <HorizontalInner>
        <div
          style={{
            position: "relative",
            //willChange: "transform",
            WebkitTransform: `translateX(${offset}px`,
            transform: `translateX(${offset}px`
          }}
        >
          <Ticks
            component={HorizontalTick}
            offset={offset}
            scaleX={props.scaleX}
            ticks={props.ticks}
          />
        </div>
      </HorizontalInner>
    </HorizontalContainer>,
    <HorizontalContainerBottom key="bottom" style={{ cursor: "default", zIndex: 2 }}>
      <HorizontalInner>
        <div
          style={{
            position: "relative",
            //willChange: "transform",
            WebkitTransform: `translateX(${offset}px`,
            transform: `translateX(${offset}px`
          }}
        >
          <Ticks
            component={HorizontalTickBottom}
            offset={offset}
            scaleX={props.scaleX}
            ticks={props.ticks}
          />
        </div>
      </HorizontalInner>
    </HorizontalContainerBottom>
  ];
}

type VerticalTicksProps = {
  scaleY: (value: number) => number,
  ticks: Array<number>,
  mobile?: boolean
};

export function VerticalTicks({ scaleY, ticks, mobile }: VerticalTicksProps) {
  if (mobile) {
    return null;
    /*const visuals = ticks.map(tick => (
      <MobileVerticalTick
        key={tick}
        style={{
          WebkitTransform: `translateY(${scaleY(tick).toFixed(2)}px`,
          transform: `translateY(${scaleY(tick).toFixed(2)}px`
        }}
      >
        {`${Math.round(tick * 10000) / 10000}`}
      </MobileVerticalTick>
    ));

    return <MobileVerticalContainer>{visuals}</MobileVerticalContainer>;*/
  }

  const visuals = ticks.map(tick => (
    <VerticalTick
      key={tick}
      style={{
        WebkitTransform: `translateY(${scaleY(tick).toFixed(2)}px`,
        transform: `translateY(${scaleY(tick).toFixed(2)}px`
      }}
    >
      {`${Math.round(tick * 10000) / 10000}`}
    </VerticalTick>
  ));

  return <VerticalContainer>{visuals}</VerticalContainer>;
}



// WEBPACK FOOTER //
// ./src/components/Chart/NextGenTicks.js